<template>
  <span style="width: 10%">{{ calculateTimeOffset(offset) }}</span>
</template>

<script>
export default {
  props: ['offset'],

  methods: {
    calculateTimeOffset (offset) {
      const mseconds = offset / 1000
      const hours = Math.floor(mseconds / 3600)

      const minutes = mseconds > 3600
        ? Math.floor((mseconds % 3600) / 60)
        : Math.floor(mseconds / 60)

      const seconds = Math.floor(mseconds % 60)

      return `${hours}:${minutes.toString().padStart(2, 0)}:${seconds.toString().padStart(2, 0)}`
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/Time.vue